<template>
  <div>
    <!-- controls -->
    <div class="field is-horizontal">
      <div class="field-body">
        <div class="field">
          <div class="control has-icons-left">
            <input class="input" type="text" placeholder="'stats.games.filter.date' | translate" readonly ref="date" :disabled="loading">
            <span class="icon is-small is-left">
              <i class="fas fa-calendar-alt"></i>
            </span>
          </div>
        </div>
        <div class="field">
          <p class="control is-expanded">
            <div class="select is-fullwidth">
              <select v-model="currency" :disabled="loading" @change="load">
                <option :value="null">{{"stats.games.filter.all currencies" | translate}}</option>
                <option v-for="c in currencies" :key="c.id" :value="c.id">{{c.id}} {{c.symbol}} - {{c.description}}</option>
              </select>
            </div>
          </p>
        </div>
      </div>
    </div>

    <!-- sort -->
    <table class="table is-size-7">
      <tr>
        <th colspan="4">{{"stats.games.filter.sort" | translate}}</th>
      </tr>
      <tr v-for="currency in sortCurrencies">
        <td><a @click="sort(currency, 'bet')">{{currency}} {{"stats.games.filter.bet" | translate}}</a></td>
        <td><a @click="sort(currency, 'win')">{{currency}} {{"stats.games.filter.win" | translate}}</a></td>
        <td><a @click="sort(currency, 'profit')">{{currency}} {{"stats.games.filter.profit" | translate}}</a></td>
        <td><a @click="sort(currency, 'rtp')">{{currency}} {{"stats.games.filter.rtp" | translate}}</a></td>
      </tr>
    </table>

    <!-- grid -->
    <table class="table is-fullwidth">
      <tr>
        <th>{{"stats.games.game" | translate}}</th>
        <th>{{"stats.games.currency" | translate}}</th>
        <th>{{"stats.games.bet" | translate}}</th>
        <th>{{"stats.games.win" | translate}}</th>
        <th>{{"stats.games.profit" | translate}}</th>
        <th>{{"stats.games.rtp" | translate}}</th>
      </tr>
      <template v-for="item in stats.items">
        <tr v-if="item.currencies.length" v-for="(c,i) in item.currencies">
          <td v-if="i == 0" :rowspan="item.currencies.length">{{item.provider}}: {{`games.${item.provider}.${item.gameId}` | translate}}</td>
          <td>{{c.currency}}</td>
          <td>{{c.bet | currency(c.currency)}}</td>
          <td>{{c.win | currency(c.currency)}}</td>
          <td :class="{'has-text-danger': c.bet < c.win, 'has-text-success': c.bet > c.win}">{{c.bet - c.win | currency(c.currency)}}</td>
          <td>{{c.win / c.bet| rtp}}%</td>
        </tr>
        <tr v-if="!item.currencies.length">
          <td>{{item.gameId}}</td>
          <td>-</td>
          <td>0</td>
          <td>0</td>
          <td>0</td>
          <td>-</td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
  import flatpickr from "flatpickr";
  import state from '../../../state';
  import dt from '../../../services/datetime.service';
  import statsService from '../../../services/stats.service';

  export default {
    name: 'stats-games',
    data() {
      return {
        loading: false,
        calendar: null,
        currency: null,
        stats: {
          items: []
        },
        sortCurrencies: []
      }
    },
    computed: {
      currencies() {
        return state.currencies.get();
      }
    },
    watch: {
    },
    async mounted() {
      var self = this;

      let start = dt.local(new Date()).add(-6, 'days').format("YYYY-MM-DD");
      let end = dt.local(new Date()).format("YYYY-MM-DD");
      this.$data.calendar = flatpickr(this.$refs.date, {
        mode: "range",
        maxDate: "today",
        defaultDate: [
          start,
          end
        ],
        onChange: function (selectedDates, dateStr, instance) {
          self.load();
        }
      });

      await this.load();
    },
    methods: {
      async load() {
        this.sortCurrencies = this.currency ? [this.currency] : [];

        const start = dt.fixDate(this.$data.calendar.selectedDates[0]);
        const end = dt.fixDate(this.$data.calendar.selectedDates[1]);
        const from = dt.local(start).utc().toISOString();
        const to = dt.local(end).endOf("day").utc().toISOString();

        let st = await statsService.getGamesStats(from, to);

        let gameStats = [];
        st.items.forEach(i => {
          let currencies = i.currencies;

          if (this.currency)
            currencies = currencies.filter(c => c.currency == this.currency);

          gameStats.push({
            gameId: i.gameId,
            provider: i.provider,
            currencies: currencies
          });

          if (!this.currency)
            i.currencies.forEach(c => {
              if (this.sortCurrencies.indexOf(c.currency) === -1)
                this.sortCurrencies.push(c.currency);
            });
        });
        this.stats.items = gameStats;
      },
      sort(currency, field) {
        this.stats.items.sort((a, b) => {
          var acur = a.currencies.filter(c => c.currency == currency)[0];
          if (!acur)
            return 1;
          var bcur = b.currencies.filter(c => c.currency == currency)[0];
          if (!bcur)
            return -1;

          if (field == 'bet')
            return bcur.bet - acur.bet;

          if (field == 'win')
            return bcur.win - acur.win;

          if (field == 'profit')
            return (bcur.bet - bcur.win) - (acur.bet - acur.win);

          // rtp
          return (bcur.win / bcur.bet) - (acur.win / acur.bet);
        });
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/client/stats/games.vue